import { Maybe, None } from "../../../misc/option";
export class StyleManager {
    constructor(identifier, clicked_fn, hovered_fn, ignored = None.instance()) {
        this.identifier = identifier;
        this.clicked_fn = clicked_fn;
        this.hovered_fn = hovered_fn;
        this.ignored = ignored;
        this.styles = [];
        this._style = None.instance();
    }
    get style() {
        return this._style;
    }
    update_style(val, mode, alt) {
        this._style = this.get_style(val)
            .mapOr(this._style, s => Maybe(s))
            .map(s => {
            s.alt = alt !== null && alt !== void 0 ? alt : false;
            s.mode = mode !== null && mode !== void 0 ? mode : '';
            return s;
        });
    }
    get_style(name) {
        const idx = this.styles.findIndex(style => style.name === name);
        return Maybe(this.styles[idx]);
    }
    get style_function() {
        return this.style.map(s => s.style_function(this.identifier, this.clicked_fn, this.hovered_fn, this.ignored));
    }
    add_styles(...styles) {
        this.styles.push(...styles);
        this._style = Maybe(this.style.mapOr(this.styles[0], s => s));
    }
}
